export const gateway = "https://qat-quickterm-bms-api.link-nonprod.wawanesalife.com";
export const LoginUrlParameter = "https://qat-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=4ntepevhn3v4pfk2smq6ib0nta&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fqat-quickterm-bms.link-nonprod.wawanesalife.com%2Fredirect";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "yes";
export const BrokerPoolClientParameter = "4ntepevhn3v4pfk2smq6ib0nta";
export const BrokerPoolDomainParameter = "qat-brokers";
export const BrokerPoolParameter = "ca-central-1_f0PTGfA8O";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://qat-quickterm-shopper.link-nonprod.wawanesalife.com";

//updated on Thu Oct 23 2025 15:43:05 GMT+0000 (Coordinated Universal Time)
